import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/i18n";

export const ToolFaq = ({ faq }) => {
  const { t } = useLang();
  return (
    <section className="mt-20 max-w-3xl" data-testid="tool-faq">
      <h2 className="text-2xl font-semibold tracking-tight text-slate-900">{t("faq.title")}</h2>
      <Accordion type="single" collapsible defaultValue="q0" className="mt-6">
        {faq.map((f, i) => (
          <AccordionItem key={f.q} value={`q${i}`} data-testid={`tool-faq-item-${i}`}>
            <AccordionTrigger className="text-left text-base font-semibold">{f.q}</AccordionTrigger>
            <AccordionContent className="text-sm leading-relaxed text-slate-600">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};
